import { render, staticRenderFns } from "./Operaciones-aplicar-precios.vue?vue&type=template&id=508069a0&"
import script from "./Operaciones-aplicar-precios.vue?vue&type=script&lang=js&"
export * from "./Operaciones-aplicar-precios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports